import React, { FC, useContext } from "react";
import { TranslationContext } from "../../context/TranslationContext";

type Props = {
  fetchResults: (shouldReset: boolean) => void;
};

const StartSearchButton: FC<Props> = ({ fetchResults }) => {
  const { i } = useContext(TranslationContext);
  return (
    <button
      data-testid="start-search-button"
      className="hover:bg-blue-700 bg-custom-blue h-[45px] md:w-[45px] w-full rounded-md border border-custom-gray flex items-center justify-center cursor-pointer focus:outline-none tooltip relative"
      onClick={() => fetchResults(true)}
    >
      <img
        alt="Start search"
        className="h-[21px] w-[21px] select-none"
        src={`/app/assets/whiteSearchIcon.svg`}
      />
      <div className="absolute left-1 top-[44px]">
        <p className="w-28">{i("Search")}</p>
      </div>
    </button>
  );
};

export default StartSearchButton;
